import React, {useState} from 'react';
import grey from '@mui/material/colors/grey';
import {
  Modal,
  Box,
  Container,
  Paper,
  Typography,
  IconButton,
  Grid,
  Switch,
  Card,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  Slider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import settings from '../spacecast/config/Settings';

export default function SettingsModal({
  isOpen,
  close,
  unitOfDistance,
  setUnitOfDistance,
}) {
  const [showLabels, setShowLabels] = useState(true);
  const [showOrbits, setShowOrbits] = useState(true);
  const [time, setTime] = useState(settings.timeSecond);

  const handleLabelsVisibility = visible => {
    setShowLabels(visible);
    if (visible) {
      window.spacecast.universe.showLabels();
    } else {
      window.spacecast.universe.hideLabels();
    }
  }

  const handleOrbitsVisibility = visible => {
    setShowOrbits(visible);
    if (visible) {
      window.spacecast.universe.showOrbits();
    } else {
      window.spacecast.universe.hideOrbits();
    }
  }

  const handleTimeChange = (newTime) => {
    setTime(newTime);
    window.spacecast.controls.settings.timeSecond = newTime;
  }

  const timeLabelFormat = (value) => `${Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}x`;

  return (
    <Modal open={isOpen}>
      <Box display="flex" alignItems="center" justifyContent="center" style={{width:'100dvw', height:'100dvh'}}>
        <Container style={{outline:'none'}}>
          <Paper style={{padding:'16px 24px', backgroundColor:grey[300]}}>
            <Box display="flex">
              <Box flex="1" display="flex" alignItems="center">
                <Typography variant="h5">Settings</Typography>
              </Box>
              <Box>
              <IconButton onClick={close}>
                <CloseIcon />
              </IconButton>
              </Box>
            </Box>
            <Grid container spacing={3} style={{marginTop:8}}>
              <Grid item xs={12} sm={6}>
                <Box display="flex" alignItems="center">
                  <Box style={{marginLeft:-12}}>
                    <Switch checked={showLabels} onChange={e => handleLabelsVisibility(e.target.checked)}/>
                  </Box>
                  <Typography variant="body2">{showLabels ? "Show labels" : "Hide labels"}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Box style={{marginLeft:-12}}>
                    <Switch checked={showOrbits} onChange={e => handleOrbitsVisibility(e.target.checked)}/>
                  </Box>
                  <Typography variant="body2">{showOrbits ? "Show orbit lines" : "Hide orbit lines"}</Typography>
                </Box>
                <Box style={{marginTop: "1rem"}}>
                  <Typography>{`Time is running at ${timeLabelFormat(time)}`}</Typography>
                  <Slider
                    value={Math.sqrt(time)}
                    min={1}
                    max={1000}
                    step={0.001}
                    scale={(x) => x ** 2}
                    onChange={(e, value) => handleTimeChange(value ** 2)}
                    valueLabelFormat={(value) => timeLabelFormat(value ** 2)}
                    valueLabelDisplay="off"
                    color="secondary"
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Card style={{backgroundColor:grey[200]}}>
                  <CardContent>
                    <Typography variant="body2" paragraph>Unit of Distance</Typography>
                    <RadioGroup name="unit" value={unitOfDistance} onChange={e => setUnitOfDistance(e.target.value)}>
                      <FormControlLabel value="km" control={<Radio />} label="Kilometer" />
                      <FormControlLabel value="mi" control={<Radio />} label="Mile" />
                      <FormControlLabel value="au" control={<Radio />} label="Astronomical Unit" />
                      <FormControlLabel value="ly" control={<Radio />} label="Light Year" />
                    </RadioGroup>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Paper>
        </Container>
      </Box>
    </Modal>
  )
}